import {Router} from 'react-router-dom';
import './config/ReactotronConfig';
import Routes from './routes';
import history from  './services/history';
import { AuthProvider } from './hooks/Auth';
import { Toaster } from 'react-hot-toast';

export function App() {
  return (
    <>
      <AuthProvider>
        <Router history={history} >
          <Routes />
        </Router>
      </AuthProvider>
      <Toaster />
    </>
  );
}


